import React from "react";

/**
 * แถบ 3 ขั้นตอนหัวหน้า VOC
 *
 * ขั้นที่ผ่านมาแล้วกดย้อนกลับได้ ขั้นที่ยังไม่ถึงกดไม่ได้
 * (กันคนกระโดดข้ามการยอมรับข้อตกลง)
 */
export default function VocSteps({ current, lang, onSelect }) {
  const steps = [
    { no: 1, th: "ข้อตกลงการใช้ระบบ", en: "Terms of Use" },
    { no: 2, th: "กรอกข้อมูล", en: "Fill in the form" },
    { no: 3, th: "บันทึกข้อมูลสำเร็จ", en: "Submitted" },
  ];

  return (
    // มือถือ: 3 ช่องติดกันเป็นแถบเดียว ตัวอักษร 2 บรรทัด / จอใหญ่: แยกเป็นปุ่ม 3 ปุ่ม
    <div className="grid grid-cols-3 gap-0 sm:gap-[12px] mt-[24px] sm:mt-[30px]">
      {steps.map((step) => {
        const isCurrent = step.no === current;
        const isDone = step.no < current;
        const clickable = isDone && typeof onSelect === "function";

        return (
          <button
            key={step.no}
            type="button"
            disabled={!clickable}
            onClick={() => clickable && onSelect(step.no)}
            className={
              `sm:rounded-[8px] px-[4px] sm:px-[16px] py-[10px] sm:py-[14px] text-small sm:text-body leading-tight text-center transition-colors ` +
              (isCurrent
                ? "bg-brand text-white font-bold"
                : isDone
                ? "bg-lightGray3 text-slateGray hover:bg-lightGray cursor-pointer"
                : "bg-lightGray3 text-metaGray cursor-not-allowed")
            }
          >
            <span className="block sm:inline font-bold sm:font-inherit">
              {lang === "th" ? `ขั้นตอนที่ ${step.no}` : `Step ${step.no}`}
            </span>{" "}
            <span className="block sm:inline">{lang === "th" ? step.th : step.en}</span>
          </button>
        );
      })}
    </div>
  );
}
